const firebaseConfig = {
  apiKey: "AIzaSyCFKD_h6tpLz0rnySAeHGhr3Isz8pwgh0U",
  authDomain: "ezasu-29931.firebaseapp.com",
  projectId: "ezasu-29931",
  storageBucket: "ezasu-29931.firebasestorage.app",
  messagingSenderId: "847788638030",
  appId: "1:847788638030:web:f7a663fcae6666eb03281f",
  measurementId: "G-4T0M5NVTPP",
};

export const firebaseVapidKey =
  process.env.REACT_APP_FIREBASE_VAPID_KEY ||
  "BNP7onEF6B5RxdVaIo_P7qN3FT6pimpdITNlfk2HYkAjSU4S_ueM7XiT7LgexD-5KGyudKOAXyO95DktE65lcsw";

export default firebaseConfig;
